const spa = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33252)">
      <path d="M8.54953 12C7.47953 11.29 6.29953 10.73 5.01953 10.39C6.29953 10.73 7.47953 11.29 8.54953 12ZM18.9795 10.39C17.6895 10.73 16.4895 11.3 15.4095 12.03C16.4895 11.3 17.6895 10.73 18.9795 10.39Z" fill="black" />
      <path d="M15.49 9.63C15.31 6.84 14.18 4.12 12.06 2C9.92 4.14 8.74 6.86 8.51 9.63C9.79 10.31 10.97 11.19 12 12.26C13.03 11.2 14.21 10.32 15.49 9.63ZM8.99 12.28C8.85 12.18 8.69 12.09 8.54 11.99C8.69 12.1 8.85 12.18 8.99 12.28ZM15.41 12.03C15.28 12.12 15.14 12.19 15.01 12.29C15.14 12.19 15.28 12.12 15.41 12.03ZM12 15.45C9.85 12.17 6.18 10 2 10C2 15.32 5.36 19.82 10.03 21.49C10.66 21.72 11.32 21.89 12 22C12.68 21.88 13.33 21.71 13.97 21.49C18.64 19.82 22 15.32 22 10C17.82 10 14.15 12.17 12 15.45Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33252">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default spa;
